import React, { Component } from 'react';
// import { connect, getFormMeta, getFormSyncErrors } from 'redux-form';
import Grid from '../layout/grid';
import TooltipWrapper from './TooltipWrapper';

export default props => {
  // Por padrão mantemos o binding do redux-form.
  // Se o chamador definir uncontrolledWhenReadOnly, removemos value/onChange
  // para evitar que campos preenchidos via jQuery/imperativo sejam limpos.
  const inputProps = { ...props.input };
  if (props.readOnly && props.uncontrolledWhenReadOnly) {
    delete inputProps.value;
    delete inputProps.onChange;
  }

  const inputEl = (
    <input
      {...inputProps}
      className={`form-control ${props.meta.touched &&
        ((props.meta.error && 'form-valid') || (props.meta.warning && 'form-valid'))}`}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      type={props.type}
      id={props.id}
      min={props.min}
      max={props.max}
      maxLength={props.maxLength}
      step={props.step}
      defaultValue={props.defaultValue}
      onKeyDown={props.onKeyDown}
    />
  );

  return (
    <Grid cols={props.cols}>
      <div className="form-group form-group-sm" style={{ position: 'relative' }}>
        {props.hideLabel ? null : (
          <label className="label-gt" htmlFor={props.name}>
            {props.label}
          </label>
        )}
        {props.tooltipText ? <TooltipWrapper tooltipText={props.tooltipText}>{inputEl}</TooltipWrapper> : inputEl}
      </div>
    </Grid>
  );
};
